export const debugModeKey = '_auth_status_checker_debug_mode';
export const storageAccessTestKey = '__logto_storage_test__';

// Domain whitelist for cross-origin communication
export const domainWhitelist = ['*.logto.io', '*.logto.dev', '*.logto-docs.pages.dev'] as const;
